export default __webpack_public_path__ + "static/media/conversation-assigned.7bf85d26.svg";